<template>
    <div>
        <ul v-if="chats.length" class="card peoples">
            <li v-for="(chat,index) in chats" :key="chat.id" @click="changeActiveChat(chat,index)"
                v-bind:class="{'selected-chat':index === activeChatIndex}">
                <figure>
                    <img :src="extractUser(chat.users).avatar"/>
                </figure>
                <div class="people-name">
                    <span>{{ extractUser(chat.users).name }}
                        <span v-if="chat.blocked" class="badge badge-danger">blocked</span>
                    </span>
                    <p v-if="chat.latest_message">
                        {{ chat.latest_message.text.substring(0,15) + "..." }}
                    </p>
                </div>
            </li>
        </ul>
        <div v-else class="alert alert-warning">
            <p>{{text.list_is_empty}}</p>
        </div>
    </div>
</template>

<script>
    import VueCookies from 'vue-cookies'

    export default {
        name: "chats",

        props: ['userId'],

        data() {
            return {
                chats: [],
                word: window.word,
                text: window.text,
                activeChatIndex: null
            };
        },

        methods: {
            fetchChats() {
                axios.get('/dashboard/chats')
                    .then(response => {
                        this.chats = response.data.data;
                        if (Vue.$cookies.isKey('active_chat_id')) {
                            let activeChat = this.chats.find(chat => chat.id == Vue.$cookies.get('active_chat_id'));
                            Bus.$emit('activeChatChanged', {chat: activeChat});
                            axios.post(`/en/dashboard/chats/${activeChat.id}/view`);
                            Vue.$cookies.remove('active_chat_id');
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    });
            },
            listenForNewEvents() {
                if (echoEnabled) {
                    Echo.private('users.' + this.userId)
                        .listen('ChatCreated', chat => {
                            console.log(chat)
                            this.chats.unshift(chat);
                        })
                        .listen('NewMessage', message => {
                            this.updateLatestMessage(message);
                            Bus.$emit('MessageReceived', message);
                        })
                        .listenForWhisper('UserTyping', function (e) {
                            this.userWhoIsTypingId = e.user_id;

                            if (this.whisperTimeout) {
                                clearTimeout(this.whisperTimeout);
                            }

                            this.whisperTimeout = setTimeout(() => this.userWhoIsTypingId = null, 1000);
                        });
                }
            },
            extractUser(users) {
                return users.find(user => {
                    return user.id !== this.userId
                });
            },
            changeActiveChat(chat, index) {
                this.activeChatIndex = index;
                Bus.$emit('activeChatChanged', {chat: chat});
                axios.post(`/en/dashboard/chats/${chat.id}/view`);
            },
            updateLatestMessage(message) {
                this.chats.map(chat => {
                    if (chat.id === message.chat.id) {
                        chat.latest_message = message
                    }
                });
            }
        },

        mounted() {
            this.fetchChats();
            this.listenForNewEvents();

            Bus.$on('MessageCreated', (message) => {
                this.updateLatestMessage(message);
            });
        },
    }
</script>
<style scoped>
    .peoples li {
        position: relative;
    }

    .selected-chat {
        background: #ccc;
    }
</style>
